import { useT } from '../i18n/useT'

// Overlay bloccante mostrato durante il redirect verso Stripe (Checkout o
// Billing Portal). Impedisce doppi tap/click mentre la tab carica l'URL
// esterno (il window.location.href può richiedere 1-2s su mobile).
export default function StripeRedirectOverlay() {
  const t = useT()
  return (
    <div className="stripe-redirect-overlay" role="alertdialog" aria-live="assertive" aria-busy="true">
      <div className="stripe-redirect-card">
        <div className="stripe-redirect-spinner" />
        <div className="stripe-redirect-title">{t('stripe_redirect_title')}</div>
        <div className="stripe-redirect-sub">{t('stripe_redirect_sub')}</div>
      </div>
    </div>
  )
}
